import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'rebuild-elasticsearch-data',

  getComponent(nextState, cb) {
    require.ensure([], require => {
      const RebuildElasticsearchDataContainer = require('./containers/RebuildElasticsearchDataContainer').default
      const rebuildElasticsearchDataReducer = require('./modules/rebuildElasticsearchData').default

      injectReducer(store, {
        key: 'rebuildElasticsearchData',
        reducer: rebuildElasticsearchDataReducer
      })

      cb(null, RebuildElasticsearchDataContainer)
    }, 'rebuildElasticsearchData')
  }
})



// WEBPACK FOOTER //
// ./src/routes/RebuildElasticsearchData/index.js